import { Paper, Stack, Typography } from '@mui/material'
import Image from 'next/image'

export function NotSupportedBanner({ title, description, wide = false }: { title: string; description: string; wide?: boolean }) {
  return (
    <Stack sx={{ px: wide ? 0 : 7, flex: 1 }} justifyContent="center" alignItems="center">
      <Paper sx={{ px: 6, py: 12, maxWidth: 350 }}>
        <Stack justifyContent="center" alignItems="center" gap={6}>
          <Image src="/app/assets/mobile-banner.png" alt="no-mobile" height={120} width={200} />
          <Stack gap={3}>
            <Typography
              variant="HeaderSubtitleLargeMedium"
              color="neutralDark.100"
              sx={{ textAlign: 'center', lineHeight: '24px' }}
            >
              {title}
            </Typography>
            <Typography variant="HeaderSubtitleMediumRegular" color="neutralLight.700" sx={{ textAlign: 'center' }}>
              {description}
            </Typography>
          </Stack>
        </Stack>
      </Paper>
    </Stack>
  )
}
